import React, { useContext } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import RoomContext from "../../context/RoomContext";
import { FormattedMessage, useIntl } from "react-intl";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { setStartLiveStreamingDialogOpen } from "../../actions/roomActions";
import TextField from "@material-ui/core/TextField/TextField";

const useStyles = makeStyles((theme) =>
  createStyles({
    setting: {
      paddingTop: theme.spacing(1),
    },
    dialogTitle: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: theme.spacing(4),
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(2),
      },
    },
    dialogActions: {
      justifyContent: "flex-end",
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(2),
      },
    },
    button: {
      width: "auto",
      marginTop: 0,
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.type === "dark" ? "#fff" : "#181C1E",
      border: "1px solid #EAEDF0",
      [theme.breakpoints.down("xs")]: {
        top: theme.spacing(1),
      },
    },
    settingsSection: {
      marginBottom: theme.spacing(1),
    },
    textFields: {
      width: 500,
    },
  })
);

const StartLiveStreaming = () => {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { roomClient } = useContext(RoomContext);
  const me = useSelector((state) => state.me);
  const room = useSelector((state) => state.room);
  const [url, setUrl] = React.useState("");

  return (
    <Dialog
      open={room.startLiveStreamingDialogOpen}
      onClose={() =>
        dispatch(
          setStartLiveStreamingDialogOpen({
            startLiveStreamingDialogOpen: false,
          })
        )
      }
    >
      <DialogTitle className={classes.dialogTitle} id="form-dialog-title">
        <FormattedMessage
          id="tooltip.startLiveStream"
          defaultMessage="Start Live Stream"
        />
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            dispatch(
              setStartLiveStreamingDialogOpen({
                startLiveStreamingDialogOpen: false,
              })
            );
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          id="url"
          className={classes.textFields}
          label={intl.formatMessage({
            id: "room.liveStreaming.url",
            defaultMessage: "RTMP Address",
          })}
          color="primary"
          value={url}
          placeholder="rtmp://a.rtmp.youtube.com/live2/sd6s-fdgd-8h84-fdgf-nfsg"
          variant="standard"
          margin="normal"
          InputProps={{
            disableUnderline: true,
          }}
          onChange={(event) => {
            const { value } = event.target;
            setUrl(value);
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          className={classes.button}
          onClick={() => {
            dispatch(
              setStartLiveStreamingDialogOpen({
                startLiveStreamingDialogOpen: false,
              })
            );
            roomClient.startRecording({ url });
          }}
          disabled={url.trim() === ""}
          variant="contained"
          color="secondary"
        >
          <FormattedMessage id="label.done" defaultMessage="Done" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StartLiveStreaming;
